import { renderSwitch,styleText } from 'app/shared/util/methode-util';
import React from 'react';
import './text-style.scss';

export interface ISmallTextWithIcone {
  text: any;
  icon?: any;
  size?: any;
  colorText?: any ;
  style?:any
}

export const SmallTextWithIcone = ({ text, icon, size = 'D',colorText='#4e4e4e',style }: ISmallTextWithIcone) => {

  return (
    <div className="small-text-with-icon">
    {icon &&  typeof icon === "string" ? <img src={icon} alt={icon}/> : icon }
      <div id="small-text" className="text" style={{ fontSize: renderSwitch(size), color:colorText,fontWeight:styleText(style) }}>{text}</div>
    </div>
  );
};
